import { twMerge } from "tailwind-merge";

import { DialogContent, DialogTitle } from "@/components/ui/dialog";

export default function ConsoleDialogContent({
    children,
    title,
    className,
    titleClassName,
}: {
    children: React.ReactNode;
    title: React.ReactNode | string;
    className?: string;
    titleClassName?: string;
}) {
    return (
        <DialogContent
            className={twMerge(
                "max-w-[800px] bg-[#F7F6FB] p-0 overflow-hidden gap-0 block [&>button]:z-[1] [&>button]:right-[30px] [&>button]:top-6 [&>button]:opacity-100 [&>button]:!ring-0 [&>button]:!ring-offset-0 [&>button>svg]:w-8 [&>button>svg]:h-8",
                className,
            )}
        >
            {title && (
                <DialogTitle
                    className={twMerge(
                        "p-[24px_65px_16px_40px] border-b border-[#ddd] text-[24px] font-[700] relative z-[1]",
                        titleClassName,
                    )}
                >
                    {title}
                </DialogTitle>
            )}
            {children}
        </DialogContent>
    );
}
